import { faqData } from '@/mocks/home';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">关于女神漫画，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqData.map((item) => (
            <div
              key={item.q}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <h3 className="font-heading text-base md:text-lg text-foreground-950 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-medium mt-0.5">
                  Q
                </span>
                {item.q}
              </h3>
              <p className="mt-3 pl-9 text-sm md:text-base text-foreground-600 leading-relaxed">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}